// Imports
import React from "react";
import formatPrice from "../../misc/functions";
import { Bar } from "react-chartjs-2";

export default function DashboardAmountChart(props) {
  const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];

  // Get last year from data
  const _getLastYear = () => {
    let year = -1;

    let orderData = props.orderData;

    for (let i = 0, len = orderData.length; i < len; i++) {
      if (+orderData[i].date.year > year) {
        year = +orderData[i].date.year;
      }
    }

    return year;
  };

  const _getChartDataFromProps = () => {
    let chartData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 12x 0 (voor iedere maand)

    let orderData = props.orderData;
    let selectedYear = props.selectedYear;

    if (selectedYear === null) {
      selectedYear = _getLastYear();
    }

    if (orderData !== undefined) {
      for (let i = 0, len = orderData.length; i < len; i++) {
        if (+orderData[i].date.year === +selectedYear) {
          chartData[orderData[i].date.month] += 1;
        }
      }
    }

    return chartData;
  };

  const _getPriceDataFromProps = () => {
    let priceData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    let orderData = props.orderData;
    let selectedYear = props.selectedYear;

    if (selectedYear === null) {
      selectedYear = _getLastYear();
    }

    if (orderData !== undefined) {
      for (let i = 0, len = orderData.length; i < len; i++) {
        if (+orderData[i].date.year === +selectedYear) {
          priceData[orderData[i].date.month] += +orderData[i].total_price;
        }
      }
    }

    return priceData;
  };

  let chartData = _getChartDataFromProps();
  let priceData = _getPriceDataFromProps();

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  const settings = props.settings;
 
  const primaryColorRGB = hexToRgb(settings.style['$color-primary'] != null ? settings.style['$color-primary'] : '#059bff');


  // Chart Data (+ colors)
  const data = {
    labels: months,
    datasets: [
      {
        backgroundColor: `rgba(${primaryColorRGB.r},${primaryColorRGB.g},${primaryColorRGB.b}, 0.3)`, 
        borderColor: `rgba(${primaryColorRGB.r},${primaryColorRGB.g},${primaryColorRGB.b}, 1)`, 
        borderWidth: 1,
        hoverBackgroundColor: `rgba(${primaryColorRGB.r},${primaryColorRGB.g},${primaryColorRGB.b}, 0.5)`, 
        hoverBorderColor: `rgba(${primaryColorRGB.r},${primaryColorRGB.g},${primaryColorRGB.b}, 1)`, 
        data: chartData,
        priceData: priceData,
      },
    ],
  };

  // Chart Options
  const options = {
    legend: {
      display: false,
    },
    animation: {
      duration: 0,
    },
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            startAtZero: true,
            stepSize: 1,
          },
        },
      ],
    },
    tooltips: {
      mode: "label",
      intersect: false,
      enabled: props.tooltipEnabled,
      callbacks: {
        title: function (tooltipItem, data) {
          //   let month = data.labels[tooltipItem[0].index];
          let month = tooltipItem[0].xLabel;

          let year = props.selectedYear;

          if (year === null) {
            year = _getLastYear();
          }

          return `Bestellingen ${month} ${year}`;
        },

        afterLabel: function (tooltipItem, data) {
          let index = tooltipItem.index;
          let price = data.datasets[0].priceData[index];

          return ` Totaal: € ${formatPrice(price)}`;
        },

        label: function (tooltipItem, data) {
          let aantal = tooltipItem.value;

          return ` Aantal: ${aantal}`;
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
}
